<kiwi-chart [titleKey]="'decisions.area.customers.distribution'"
            [labelKey]="'decisions.area.customers.number'"
            [barChartLabels]="barChartLabels"
            [barChartData]="barChartData"
            [options]="barChartOptions">
</kiwi-chart>
